import { IconButton, PanelType, PrimaryButton } from "@fluentui/react";
import { DetailsList, Label, MessageBar, MessageBarType, SelectionMode } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { Fragment } from "react";
import Scriba from 'react-scriba';
import { MaxLengths } from "../../../data/MaxLenghts";
import { Immocom } from '../../../specifique/immocom';
import { EUIDialog } from "../../EUI/EUIDialog";
import { EUIPanel } from "../../EUI/EUIPanel";
import { EUITextField } from "../../EUI/EUITextField";
import { ProgressIndicatorChargement } from "../../Loader/ProgressIndicatorChargement";
import { Upload } from "../../Outils/Upload";

class FicheEnvoiMultiple extends Component {

    static defaultProps = {
        destinataires: [
            //{
            //    idContactChiffre: undefined, // id chiffré du contact rattaché à la conversation
            //    idOperation: undefined,
            //    idReservation: undefined,
            //    nomComplet: undefined, // nom et prénom de l'interlocuteur
            //}
        ],
        estOnline: false,
        hubConnection: undefined,
        isOpen: false,
        loginCompte: undefined, // login du compte utilisé par le backoffice
        /* --- */
        onDismiss: () => null,
        onOpen: () => null,
        onRemovalDestinataire: (idContactChiffre, idReservation) => null,
        onSend: () => null,
    };

    static defaultState = {
        texte: undefined,
        piecesJointes: []
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheEnvoiMultiple.defaultState };
    };

    _envoyerMessage = () => {

        const { destinataires, hubConnection, loginCompte } = this.props;
        const { texte, piecesJointes } = this.state;

        const jDestinataires = destinataires.map(destinataire => {
            const { idContactChiffre, idOperation, idReservation } = destinataire;
            return { idContactChiffre, idOperation, idReservation }
        });

        if (!!hubConnection) {

            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: "Envoi en cours..."
            });

            hubConnection.invoke("EnvoyerMessageMultiple", jDestinataires, texte, piecesJointes, loginCompte).then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const state = { afficherDialog: true };
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });

        }
    };

    _onDismiss = () => {
        this.setState(prevState => ({ ...FicheEnvoiMultiple.defaultState }));
        this.props.onDismiss();
    };

    _onOpen = () => {
        this.setState({ ...FicheEnvoiMultiple.defaultState });
    };

    _onUpload = (event) => {
        const files = event.target.files;
        if (files.length > 0) {
            for (var i = 0; i < files.length; i++) {
                const reader = new FileReader();
                const file = files[i];
                reader.addEventListener("load", () => {
                    let piecesJointes = [...this.state.piecesJointes];
                    const key = Math.max(...piecesJointes.map(item => item.key), 0) + 1;
                    piecesJointes.push({
                        key,
                        fileData: Scriba.fichier().ByteArrayVersBase64(reader.result),
                        nom: file.name,
                        size: file.size / 1024 / 1024
                    });
                    this.setState({ piecesJointes });
                })
                reader.readAsArrayBuffer(file);
            }
        }
    };

    _removeDestinataire = (idContactChiffre, idReservation) => () => {
        const { onRemovalDestinataire } = this.props;
        if (!!onRemovalDestinataire) onRemovalDestinataire(idContactChiffre, idReservation);
    };

    _removePieceJointe = (key) => () => {
        this.setState((prev) => ({ piecesJointes: [...prev.piecesJointes.filter(item => item.key !== key)] }));
    };

    render = () => {

        const { destinataires, estOnline, isOpen, onSend } = this.props;
        const { afficherDialog, errorMessage, piecesJointes, texte } = this.state;

        const MAX_FILE_SIZE = 10;
        const totalSize = piecesJointes.reduce((memo, pj) => memo += pj.size, 0);
        const nbDestinataires = !!destinataires && Array.isArray(destinataires) ? destinataires.length : 0;
        const nbReservations = !!destinataires && Array.isArray(destinataires)
            ? [...new Set(destinataires.map(d => `${d.idOperation}-${d.idReservation}`))].length
            : 0;

        return <EUIPanel
            headerText="Envoi multiple"
            isOpen={isOpen}
            onDismiss={this._onDismiss}
            onOpen={this._onOpen}
            onSend={this._envoyerMessage}
            type={PanelType.medium}
            isFormValid={!!estOnline && !!destinataires && destinataires.length > 0 && !!texte && totalSize <= MAX_FILE_SIZE}
        >

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            {!estOnline && <MessageBar messageBarType={MessageBarType.error}>Connection avec le serveur de messagerie impossible...</MessageBar>}

            {!!errorMessage && <MessageBar messageBarType={MessageBarType.error}>{errorMessage}</MessageBar>}

            <Label>Opérations</Label>
            {!!destinataires && Array.isArray(destinataires) &&
                <DetailsList
                    columns={[{ fieldName: "nomOperation", key: "nomOperation" }]}
                    compact
                    isHeaderVisible={false}
                    items={[...new Set(destinataires.map(d => d.nomOperation))].map(nomOperation => ({ nomOperation }))}
                    selectionMode={SelectionMode.none}
                />
            }

            <Label>Destinataires ({nbDestinataires} clients / {nbReservations} réservations)</Label>
            {!!destinataires && Array.isArray(destinataires) &&
                <DetailsList
                    columns={[
                        {
                            key: "delete", minWidth: 20, maxWidth: 20, onRender: (item) =>
                                <IconButton
                                    disabled={destinataires.length === 1}
                                    iconProps={{ iconName: "Trash" }}
                                    onClick={this._removeDestinataire(item.idContactChiffre, item.idReservation)}
                                    styles={{ root: { height: "inherit" } }}
                                />
                        },
                        { fieldName: "numero", key: "numero", minWidth: 50, maxWidth: 50 },
                        { fieldName: "nomComplet", key: "nomComplet" },
                    ]}
                    compact
                    isHeaderVisible={false}
                    items={destinataires}
                    selectionMode={SelectionMode.none}
                />
            }

            <EUITextField
                label="Message"
                maxLength={MaxLengths.message.texte}
                multiline
                onChange={(event, newValue) => this.setState({ texte: newValue })}
                rows={15}
                value={texte}
            />

            <Upload
                label="Sélectionnez une ou plusieurs pièces jointes"
                multiple
                onChange={event => this._onUpload(event)}
            />

            <Label>Pièces jointes</Label>
            {!!piecesJointes && piecesJointes.length === 0
                ? <div>Aucun document n'a été joint au message</div>
                : <Fragment>
                    {totalSize > MAX_FILE_SIZE && <MessageBar messageBarType={MessageBarType.error}>{`Document(s) trop volumineux (total ${MAX_FILE_SIZE} Mo max.)`}</MessageBar>}
                    <DetailsList
                        columns={[
                            {
                                key: "delete", minWidth: 20, maxWidth: 20, onRender: (item) =>
                                    <IconButton
                                        iconProps={{ iconName: "Trash" }}
                                        onClick={this._removePieceJointe(item.key)}
                                        styles={{ root: { height: "inherit" } }}
                                    />
                            },
                            { fieldName: "nom", key: "nom" },
                            { key: "size", minWidth: 50, maxWidth: 50, onRender: item => `${item.size.toFixed(2)} Mo` },
                        ]}
                        compact
                        isHeaderVisible={false}
                        items={piecesJointes}
                        selectionMode={SelectionMode.none}
                    />
                </Fragment>
            }

            <EUIDialog
                buttons={[<PrimaryButton key="close" onClick={() => this.setState({ afficherDialog: false }, onSend)} text="Fermer" />]}
                isOpen={afficherDialog}
                onDismiss={() => this.setState({ afficherDialog: false }, onSend)}
                titre="Message envoyé"
            />

        </EUIPanel>;

    };

}

export default FicheEnvoiMultiple;